// utils/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ allowedRole, children }) => {
  const role = localStorage.getItem("user_role");
  if (role === allowedRole) {
    return children;
  } else {
    return <Navigate to="/" />;
  }
};

export default ProtectedRoute;
